import { render, staticRenderFns } from "./FleteAlmacenamientoPage.vue?vue&type=template&id=832638aa"
import script from "./FleteAlmacenamientoPage.js?vue&type=script&lang=js&external"
export * from "./FleteAlmacenamientoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports